import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ContentProvider } from "./lib/content";
import "./index.css";
import "./qaida-interactive.css";
import "./polish.css";
import "./classroom.css";
import "./home.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ContentProvider>
      <App />
    </ContentProvider>
  </StrictMode>,
);
